/* Homepage fit finder: matches the customer's joint against every product's variant names, in the browser. */
(function () {
  'use strict';

  /* same reading as the product page's joint picker: "14mm Male 90", "14mm 90° male", "11mm(SPECIAL) Male 55°" */
  function parseJoint(value) {
    var out = { size: '', type: '', angle: '' }, rest = 0;
    String(value).replace(/\([^)]*\)/g, '').replace(/\*.*$/, '').replace(/[,/]/g, ' ').split(/\s+/).forEach(function (w) {
      var lw = w.toLowerCase().trim(); if (!lw) return;
      var n = lw.replace(/mm|°|deg(rees)?/g, '');
      if (/mm$/.test(lw) && /^\d+(\.\d+)?$/.test(n)) out.size = n;
      else if (lw === 'male' || lw === 'm') out.type = 'male';
      else if (lw === 'female' || lw === 'f') out.type = 'female';
      else if (/^\d+(\.\d+)?$/.test(n)) { if (out.size) out.angle = n; else out.size = n; }
      else rest++;
    });
    return out.size && out.type && !rest ? out : null;
  }
  var DIMS = ['size', 'type', 'angle'];
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  class HeFitFinder extends HTMLElement {
    connectedCallback() {
      var raw = this.querySelector('[data-fit-data]'); if (!raw) return;
      var data; try { data = JSON.parse(raw.textContent); } catch (e) { return; }
      /* one entry per product: its variants that read as joints */
      this.products = data.map(function (p) {
        return { t: p.t, u: p.u, i: p.i, v: p.v.map(function (v) { return { id: v[0], name: v[1], ok: v[2], price: v[3], j: parseJoint(v[1]) }; }).filter(function (v) { return v.j; }) };
      }).filter(function (p) { return p.v.length; });
      if (!this.products.length) return;
      this.pick = { size: '', type: '', angle: '' };
      this.limit = parseInt(this.dataset.limit, 10) || 8; this.expanded = false;
      this.list = this.querySelector('[data-fit-list]'); this.count = this.querySelector('[data-fit-count]');
      this.more = this.querySelector('[data-fit-more]'); this.empty = this.querySelector('[data-fit-empty]'); this.reset = this.querySelector('[data-fit-reset]');
      this.buildGroups();
      var self = this;
      this.addEventListener('click', function (e) {
        var b = e.target.closest('[data-dim]');
        if (b) { var d = b.dataset.dim; self.pick[d] = self.pick[d] === b.dataset.value ? '' : b.dataset.value; self.expanded = false; self.render(); return; }
        if (e.target.closest('[data-fit-reset]')) { self.pick = { size: '', type: '', angle: '' }; self.expanded = false; self.render(); return; }
        if (e.target.closest('[data-fit-more]')) { self.expanded = true; self.render(); }
      });
      this.render();
    }
    buildGroups() {
      var vals = { size: [], type: [], angle: [] };
      this.products.forEach(function (p) { p.v.forEach(function (v) { DIMS.forEach(function (d) { if (v.j[d] && vals[d].indexOf(v.j[d]) < 0) vals[d].push(v.j[d]); }); }); });
      vals.size.sort(function (a, b) { return a - b; }); vals.angle.sort(function (a, b) { return b - a; }); vals.type.sort();
      var labels = { size: this.dataset.lSize, type: this.dataset.lType, angle: this.dataset.lAngle };
      var html = '';
      DIMS.forEach(function (d) {
        if (!vals[d].length) return;
        html += '<fieldset><legend>' + esc(labels[d]) + '</legend><div class="seg">' + vals[d].map(function (v) {
          var text = d === 'size' ? v + ' mm' : d === 'angle' ? v + '°' : v.charAt(0).toUpperCase() + v.slice(1);
          return '<button type="button" data-dim="' + d + '" data-value="' + esc(v) + '" aria-pressed="false">' + esc(text) + '</button>';
        }).join('') + '</div></fieldset>';
      });
      this.querySelector('[data-fit-groups]').innerHTML = html;
    }
    matches(v, pick, skip) {
      return DIMS.every(function (d) { return d === skip || !pick[d] || v.j[d] === pick[d]; });
    }
    render() {
      var self = this, pick = this.pick, any = DIMS.some(function (d) { return pick[d]; });
      /* each product shows its best matching variant: in stock first */
      var hits = [];
      this.products.forEach(function (p) {
        var vs = p.v.filter(function (v) { return self.matches(v, pick); });
        if (!vs.length) return;
        var best = vs.filter(function (v) { return v.ok; })[0] || vs[0];
        hits.push({ p: p, v: best, ok: best.ok });
      });
      hits.sort(function (a, b) { return (b.ok ? 1 : 0) - (a.ok ? 1 : 0); });
      /* buttons: pressed state, and dim the ones that would lead nowhere with the other picks */
      this.querySelectorAll('[data-dim]').forEach(function (b) {
        var d = b.dataset.dim, val = b.dataset.value;
        b.setAttribute('aria-pressed', pick[d] === val ? 'true' : 'false');
        var test = Object.assign({}, pick); test[d] = val;
        var possible = self.products.some(function (p) { return p.v.some(function (v) { return self.matches(v, test); }); });
        if (possible) b.removeAttribute('data-unavailable'); else b.setAttribute('data-unavailable', '');
      });
      this.reset.hidden = !any;
      var label = DIMS.map(function (d) { return pick[d] ? (d === 'size' ? pick[d] + ' mm' : d === 'angle' ? pick[d] + '°' : pick[d]) : ''; }).filter(Boolean).join(' ');
      this.count.innerHTML = any
        ? this.dataset.tCount.replace('[count]', '<b>' + hits.length + '</b>').replace('[joint]', esc(label))
        : esc(this.dataset.tAll.replace('[count]', hits.length));
      this.empty.hidden = hits.length > 0; this.list.hidden = !hits.length;
      var shown = this.expanded ? hits : hits.slice(0, this.limit);
      this.list.innerHTML = shown.map(function (h) {
        var url = h.p.u + (any ? '?variant=' + h.v.id : '');
        return '<li><div class="tile">' +
          '<div class="tile__media media">' + (h.p.i ? '<img src="' + esc(h.p.i) + '" alt="" loading="lazy" width="480" height="480">' : '') + '</div>' +
          (h.ok ? '' : '<div class="tile__badges"><span class="badge badge--soldout">' + esc(self.dataset.tSoldout) + '</span></div>') +
          '<a class="tile__title" href="' + esc(url) + '">' + esc(h.p.t) + '</a>' +
          (any ? '<span class="tile__spec">' + esc(h.v.name) + '</span>' : '') +
          '<div class="price"><span class="price__regular">' + esc(h.v.price) + '</span></div></div></li>';
      }).join('');
      this.more.hidden = this.expanded || hits.length <= this.limit;
      this.more.textContent = this.dataset.tMore.replace('[count]', hits.length);
    }
  }
  if (!customElements.get('he-fit-finder')) customElements.define('he-fit-finder', HeFitFinder);
})();
